import {white} from '/theme/color/on.color';

export const styleMutation = ({index, colorScale}: any) => ({
  fill: colorScale[index],
  stroke: white,
  strokeWidth: 3,
});
